import type { JSX } from 'react'

export const RewindRightIcon = (): JSX.Element => (
  <use href='#rewindRightIcon' height='100%' width='100%' />
)
